'use strict';

class notificationService {
  constructor($http) {
    this.$http = $http;
  }

  getLoginMessages() {
    return this.$http.get(`/notifications/public/login`)
      .then((resp) => resp.data);
  }

  getMessages() {
    return this.$http({
      method: 'GET',
      url: `/notifications/`,
      ignoreAuth: true
    })
      .then((resp) => resp.data);
  }

  markAsRead(id) {
    return this.$http.post(`/notifications/${id}/read`);
  }
  getLastMonthNews() {
    return this.$http({
      method: 'GET',
      url: `/notifications/news/lastMonth`,
      ignoreAuth: true
    })
      .then((resp) => resp.data);
  }

  markNewsAsRead(id) {
    return this.$http.post(`/notifications/news/${id}/read`);
  }
}

notificationService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('notificationService', notificationService);
